import { useState } from 'react';
import type { SectionKey } from '../../api/navigation.ts';
import { useTaskDepartments } from '../../api/taskQueries.ts';
import { sectionActionDepartment } from '../../tasks/sectionDepartment.ts';
import { RecordActionSheet } from './RecordAction.tsx';
import { go } from './Fields.tsx';

/**
 * "Record an action" in a department section of the client page (A-#144): the client is the page's and the department
 * the section's, never chosen in a form. Drawn only where the reader holds that department; the server checks it again.
 */
export function SectionAction({ section, client }: { section: SectionKey; client: { id: string; name: string; ref: string | null } }) {
  const departments = useTaskDepartments();
  const [open, setOpen] = useState(false);
  const department = sectionActionDepartment(section, departments.data?.action);
  if (department === null) return null;
  return (
    <div className="panel mb-3 px-4 py-3">
      <button type="button" className={go} onClick={() => setOpen(true)}>Record an action</button>
      {open && <RecordActionSheet client={client} department={department} onClose={() => setOpen(false)} />}
    </div>
  );
}
